import React from 'react'
import styles from '../styles'
import { NavLink } from 'react-router-dom'

const HeaderUserInfoView = ({ name, role, dropDownOpened, toggleDropDown }) => (
  <section style={styles.container}>
    <div styles={styles.dropDownWrapper}>
      <div onClick={toggleDropDown} style={styles.mediumText}>
        {name} <i style={dropDownOpened ? styles.arrowUp : styles.arrowDown} />
      </div>
      <div
        style={
          dropDownOpened
            ? styles.dropdownContainerOpened
            : styles.dropdownContainerHidden
        }
      >
        <NavLink to="/dashboard/profile" style={styles.dropdownItem}>
          Profile
        </NavLink>
        <NavLink to={'/logout'} style={styles.dropdownItem}>
          Logout
        </NavLink>
      </div>
    </div>
    <div style={styles.smallItalicText}>{role}</div>
  </section>
)

export default HeaderUserInfoView



// WEBPACK FOOTER //
// ./src/Components/Header/HeaderUserInfo/component/HeaderUserInfoView.js